<template>
  <div>
    <div class="px-4 sm:px-0">
      <PageTitle
        :title="$gettext('Profil')"
        :description="$gettext('Informations personelles.')"
      />
    </div>
    <div class="mt-6 border-t border-gray-100">
      <dl class="divide-y divide-gray-100">
        <div v-if="organization" class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
          <dt class="text-sm/6 font-medium text-gray-900">{{ $gettext("Orgnisation") }}</dt>
          <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{{ organization.attributes.name }}</dd>
        </div>
        <div v-if="user" class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
          <dt class="text-sm/6 font-medium text-gray-900">{{ $gettext("Nom complet") }}</dt>
          <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{{ user.name }}</dd>
        </div>
        <div v-if="user" class="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
          <dt class="text-sm/6 font-medium text-gray-900">{{ $gettext("Adresse email") }}</dt>
          <dd class="mt-1 text-sm/6 text-gray-700 sm:col-span-2 sm:mt-0">{{ user.email }}</dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import PageTitle from "@/components/layout/PageTitle.vue";
import { useOrganizationStore } from "@/stores/organization.js";
import { useOrganizationRiskScoringRuleStore } from "@/stores/organizationRiskScoringRule.js";

import { ref, onMounted } from "vue";

const { user } = useAuth0();
const organizationStore = useOrganizationStore();
const organization = ref(null);
const selectedOrganizationRiskScoringRules = ref([]);
const organizationRiskScoringRuleStore = useOrganizationRiskScoringRuleStore();

onMounted(async () => {
  await organizationRiskScoringRuleStore.fetchOrganizationRiskScoringRules();
  selectedOrganizationRiskScoringRules.value = organizationRiskScoringRuleStore.sortedOrganizationRiskScoringRules;
  let organizationId = selectedOrganizationRiskScoringRules.value[0].attributes.organizationId;
  organization.value = await organizationStore.fetchOne(organizationId);
});
</script>
